/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
// @flow

import { createStore, applyMiddleware, compose, Store } from 'redux';
import middlewares from './middlewares';
import reducers from './reducers/root-reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/// <summary>
/// Creates store and sets it into singleton (Store.ts/store)
/// </summary>
const createAppStore = () => {
  let store = createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)));

  return store;
};

// initialize
export let store: Store = createAppStore();
